import { EmptyStateContainer } from 'components/SectionTable';
import styled from 'styled-components';
import { Modal } from 'styles/modals';

export const ButtonContainer = styled.div`
  margin-top: 8px;
`;

export const MaxWidthModal = styled(Modal)`
  max-width: 600px;
`;

export const LoadingContainer = styled.div`
  height: 220px;
`;

export const DataSourceEmptyState = styled(EmptyStateContainer)`
  justify-content: center;
  padding-left: 20%;
  padding-right: 20%;
  gap: 1rem;
`;
